export default __webpack_public_path__ + "static/media/WB.2b1ab403.svg";